export default __webpack_public_path__ + "static/media/Nunito-Black.68bc0a94.woff2";